var _defs, _path, _path2, _ellipse, _ellipse2, _path3, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamlySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.15 130.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb915;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.19,129.42l.03-27.87c1.14-7.05,6.52-12.16,13.52-13.59,4.95-1.01,8.67-4.14,9.66-9.26,1.28-6.58-2.44-10.48.94-12.59,6.18-3.85,14.06-4.5,20.61-1.36,7.14,3.43,10.94,10.28,10.07,18.16-1.07,9.61-5.8,18.67-14.13,23.94l-37.84,23.96c-1.13.37-2.86.08-2.85-1.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.35,68.21c-10.87,2.44-21.54,2.41-32.18.04l-14.73-4.34c-1.03-.3-1.18-1.63-.69-2.46,4.66-7.96,11.94-13.36,20.81-16.15,15.71-4.93,33.06,1.58,41.64,15.58.45.73.66,1.4.55,1.92-.18.87-.85,1.3-1.72,1.54l-13.68,3.87Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 67.53,
    cy: 17.79,
    rx: 17.8,
    ry: 17.79
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 114.87,
    cy: 42.93,
    rx: 15.43,
    ry: 15.42
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.05,101.48v27.6c-.02.69-.46,1.31-.87,1.55-.52.29-1.4.41-2.1-.03l-34.91-21.85c-8.88-5.56-15.09-13.81-16.86-24.11-1.61-9.39,3.22-17.78,12.41-20.83,5.75-1.91,12.17-1.2,17.64,1.62,1.82.94,2.59,2.52,2.02,4.57-1.22,4.33-1.14,9.16,1.36,13,1.96,3.01,5.24,4.33,8.6,5.13,6.57,1.58,11.57,6.5,12.72,13.35Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 19.5,
    cy: 42.94,
    rx: 15.44,
    ry: 15.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamlySmall);
export default __webpack_public_path__ + "static/media/teamly-small.1ba96974993d79ac2ceb1df46d602dea.svg";
export { ForwardRef as ReactComponent };